<template>
  <v-tooltip
    top
    allow-overflow
    max-width="250px"
    :disabled="count===0"
  >
    <v-btn
      @click="toggleLike()"
      flat
      slot="activator"
    >
      <v-icon v-html="icon"></v-icon>
      <span>{{likeCount}}</span>
    </v-btn>
    <span class="likes" v-if="likers && likers.length">
      <span class="like" v-for="(liker, idx) in likers" :key="liker.user.id" >
        {{liker.user.display_name}}<span v-if="idx != likers.length - 1">, </span>
      </span>
    </span>
  </v-tooltip>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
span {
  color: $font-color;
  font-weight: normal;
  .like, .like>* {
    color: white;
  }
}
.v-tooltip__content {
  * {
    color: white;
  }
}
.v-btn {
  padding: 0;
  min-width: 3em !important;
}
</style>

<script>
export default {
  props: ["cardId", "groupId", "inputLikers"],
  computed: {
    likeCount: function() {
      return this.count < 1 ? " " : (this.count < 1000 ? this.count : "999+");
    }
  },
  data() {
    return {
      icon: "",
      icons: {
        active: "$vuetify.icons.amaze-heart-filled",
        inactive: "$vuetify.icons.amaze-heart"
      },
      count: null,
      likers: this.inputLikers.filter(function(e) {
        return e.hasOwnProperty('user') && e.user;
      })
    };
  },
  methods: {
    toggleLike() {
      let data = {
        user_id: this.$auth.user().id,
        card_id: this.cardId,
        group_id: this.groupId
      };
      this.$http.post("cardLikes", data).then(
        response => {
          if (response.body.data.created) {
            this.likers.push(response.body.data);
            this.icon = this.icons.active;
          } else {
            this.icon = this.icons.inactive;
            this.likers = this.likers.filter(e => {
              return e.hasOwnProperty('user_id') && e.user_id !== this.$auth.user().id;
            });
          }
          this.count = this.likers.length;
        },
        response => {
          console.log("Error sending like!");
        }
      );
    }
  },
  mounted() {
    this.count = this.likers.length;

    let includeMe = this.likers.find(element => {
      return element.hasOwnProperty('user_id') && this.$auth.user().id === element.user_id;
    });

    if (includeMe) {
      this.icon = this.icons.active
      this.iLiked = true;
    } else {
      this.icon = this.icons.inactive
      this.iLiked = false;
    }
  }
};
</script>
